import "./BranchesInfoContentItem.scss";

interface BranchesInfoContentItemProps {
  icon: React.ReactNode;
  field: string | JSX.Element;
  text: string;
}

export function BranchesInfoContentItem({
  icon,
  field,
  text,
}: BranchesInfoContentItemProps) {
  return (
    <div className="branches-info-content-item">
      <div className="branches-info-content-item__icon">{icon}</div>
      <div className="branches-info-content-item-description">
        <div className="branches-info-content-item__field">
          {" "}
          <span className="fieldTitle"> {field} </span>{" "}
          <span className="hoursTitle" dangerouslySetInnerHTML={{__html:text}}/>
        </div>
        {/* <div className="branches-info-content-item__text">{text}</div> */}
      </div>
    </div>
  );
}
